<template>
  <div class="search_container" v-if="readyToRender">
        <div class="form-group filter">
          <label>Agence : </label>
          <custom-select style="width:350px !important;" :field="fields[0]" :value="fields[0].value" :field_idx="0"
            @field-updated="fields_update_handler('agency', $event)">
          </custom-select>
        </div>

        <div class="form-group filter">
          <label>Statut : </label>
          <custom-select style="width:250px !important;" :field="fields[1]" :value="fields[1].value" :field_idx="1"
            @field-updated="fields_update_handler('status', $event)" >
          </custom-select>
        </div>

        <div class="form-group filter">
          <label>Groupe : </label>
          <custom-select style="width:250px !important;" :field="fields[2]" :value="fields[2].value" :field_idx="2"
            @field-updated="fields_update_handler('group', $event)" >
          </custom-select>
        </div>
  </div>
</template>

<script>
import CustomSelect from "components/Forms/Elements/Select"
import {mapState, mapActions} from "vuex"
export default {

  name:"DemandsSearchBar",
  components:{
    CustomSelect
  },

  data(){
    return {
      current_agency_id:null,
      statusFilter:[
        {id:0, text:"En attente", data:"pending"} ,
        {id:1, text:"Validée", data:"validated"},
        {id:2, text:"Refusée", data:"refused"}
      ],
      groupFilter:[
        {id:0, text:"Tous", data:"all"} ,
        {id:1, text:"Contrats", data:"contract"},
        {id:2, text:"Clients", data:"customer"}
      ],
    }
  },

  methods :{
    ...mapActions("validationRequestsV2", ["updateFilter"]),

    data_of_value(field_name,  v) {
      let srcs = null

      if (field_name == 'status') {
        srcs = this.statusFilter
      } else if (field_name == 'group') {
        srcs = this.groupFilter
      }

      let found = _.find(srcs, s => s.id == v)

      return found != undefined ? found.data : null
    },

    fields_update_handler(field_name, event)
    {
      $('.clear').remove()
      let current_filters = _.clone(this.filters)

      if (field_name == 'agency') {
        current_filters = _.assign(current_filters, {agency_id:event.new_value != null ? event.new_value.value : this.main_agency.id})
      } else if (field_name == 'status') {
        current_filters = _.assign(current_filters, {status:event.new_value != null ? this.data_of_value(field_name, event.new_value.value) : this.data_of_value(field_name, 0)})
      } else if (field_name == 'group') {
        current_filters = _.assign(current_filters, {group:event.new_value != null ? this.data_of_value(field_name, event.new_value.value) : this.data_of_value(field_name, 0)})
      }

      this.updateFilter(current_filters)
    }
  },
  computed : {
    ...mapState(["user","agencies"]),
    ...mapState("validationRequestsV2", ["filters"]),

    valid_agencies() {
      return _.filter(this.agencies, a => !a.archived)
    },

    main_agency() {
      if (this.user && this.user.me)
      {
        let found = _.find(this.user.me.agencies, v => !v.virtual)
        return found != undefined ? found : null
      }
      return null
    },

    readyToRender() {
      if(this.main_agency != null && this.valid_agencies.length > 0)
        {
          this.current_agency_id = this.main_agency.id
          return true
        }
      return false
    },

    fields(){
      let v = [
          {values:this.valid_agencies, multiple:false, placeholder:"", disabled:this.is_fetching, idx:0, required:false, value:this.current_agency_id, label:"Agence",type:"select"},
          {values:this.statusFilter, multiple:false, placeholder:"", disabled:this.is_fetching, idx:1, required:false, value:0, label:"Statut",type:"select"},
          {values:this.groupFilter, multiple:false, placeholder:"", disabled:this.is_fetching, idx:2, required:false, value:0, label:"Groupe",type:"select"},
      ]
      return v
    }
  },
}
</script>

<style scoped>

div.search_container {
  display: flex;
}

div.filter {
  margin-left:5px;
  margin-right: 5px;
}
div.filter:last-child {
  margin-right: none;
}
div.filter:first-child {
  margin-left: none;
}
</style>



// WEBPACK FOOTER //
// client/views/Demands/SearchBar.vue